import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import $ from 'jquery';
var ATTR_KEY = 'data-key';
var URL = 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe';
var PLATFORM = 'shopify';
export var backInStockForm = function backInStockForm(form, formSelector, messageDefaultSelector, messageSuccessSelector, messageErrorSelector) {
  backInStockPromise(form).then(function (data) {
    if (data.success) {
      formSelector.find(messageDefaultSelector).addClass('is-hidden');
      formSelector.find(messageErrorSelector).addClass('is-hidden');
      formSelector.find(messageSuccessSelector).removeClass('is-hidden');
      form.addClass('is-hidden');
    }
  }).catch(function (error) {
    formSelector.find(messageDefaultSelector).addClass('is-hidden');
    formSelector.find(messageErrorSelector).removeClass('is-hidden');
  });
};
var backInStockPromise = function backInStockPromise(form) {
  return new Promise(function (resolve, reject) {
    if (!form) throw 'Invalid input';
    var KEY = form.attr(ATTR_KEY);
    var email = form.find('input[type="email"]').val();
    var variant = form.find('input[name="variant"]').val();
    var re = /\S+@\S+\.\S+/;
    if (!email || !re.test(email)) throw 'Invalid input';
    if (!variant) throw 'Invalid variant';
    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: URL,
      data: {
        a: KEY,
        email: email,
        variant: variant,
        platform: PLATFORM
      },
      success: function success(data) {
        try {
          if (data.success) resolve(data);
        } catch (ex) {
          return reject(ex);
        }
      },
      error: function error(jqXHR, status, _error) {
        return reject(_error);
      }
    });
  });
};